import { render, staticRenderFns } from "./BaseEstadoVacio.vue?vue&type=template&id=7f5be20b&scoped=true"
import script from "./BaseEstadoVacio.vue?vue&type=script&lang=js"
export * from "./BaseEstadoVacio.vue?vue&type=script&lang=js"
import style0 from "./BaseEstadoVacio.vue?vue&type=style&index=0&id=7f5be20b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5be20b",
  null
  
)

export default component.exports